import React from 'react';
import { Container, Title, Text, TitleProps } from '@soluto-design/react';
import BlogShare from '../../molecules/BlogShare';
import Form, { FormProps } from '../../molecules/Form';

import cls from '@soluto-design/styles/cls';

export interface FormSectionProps {
    title?: string;
    titleTag?: TitleProps['component'];
    text?: string;
    address?: string;
    twitterUrl?: string;
    linkedinUrl?: string;
    youtubeUrl?: string;
    instagramUrl?: string;
    form?: FormProps;
    previousSectionType?: string;
}

export default function FormSection({
    title,
    titleTag = 'h2',
    text,
    address,
    twitterUrl,
    linkedinUrl,
    youtubeUrl,
    instagramUrl,
    form,
    previousSectionType,
}: FormSectionProps) {
    const socialLinks = [
        { url: twitterUrl, icon: 'twitter', title: 'Twitter' },
        { url: linkedinUrl, icon: 'linkedin', title: 'LinkedIn' },
        { url: instagramUrl, icon: 'instagram', title: 'Instagram' },
        { url: youtubeUrl, icon: 'youtube', title: 'YouTube' },
    ].filter((link) => link.url);

    return (
        <section
            data-theme="dark"
            className={cls('pt-xl pb-xxxl', !previousSectionType && 'mt-xxxl')}>
            <Container className="row gap-y-xxxl">
                {
                    <div className="col-span-full lg:col-span-3 xl:col-span-4 lg:h-fit lg:sticky lg:top-xl">
                        {!!title && (
                            <Title
                                component={titleTag}
                                className="text-h200 text-text-primary pb-32">
                                {title}
                            </Title>
                        )}
                        {!!text && (
                            <Text
                                isHtml
                                component="div"
                                className="text-b400 text-text-secondary [&_p]:pb-12 [&>p:last-child]:pb-0 [&_strong]:font-regular [&_strong]:text-text-primary [&_strong]:text-b300">
                                {text}
                            </Text>
                        )}
                        {!!address && (
                            <Text
                                isHtml
                                component="div"
                                className="text-b400 text-text-primary [&_a]:!no-underline [&_a]:!font-regular pt-xl">
                                {address}
                            </Text>
                        )}
                        {socialLinks && socialLinks.length > 0 && (
                            <div className="pt-xs">
                                <BlogShare links={socialLinks} />
                            </div>
                        )}
                    </div>
                }

                {form && (
                    <div className="bg-background-secondary p-24 md:p-32 lg:xl-[40px] rounded-large col-span-full lg:col-span-4 xl:col-span-6 lg:col-start-5 xl:col-start-7">
                        <Form {...form} />
                    </div>
                )}
            </Container>
        </section>
    );
}
